/**
 * Tipos de sensor exibidos no mapa de equipamentos.
 * null = todos os tipos. Para restringir, use um Set de tipoSensorId.
 */
export const SENSOR_MAPA_WHITELIST_IDS = null

export function isSensorNoMapa(sensor) {
  if (SENSOR_MAPA_WHITELIST_IDS == null) {
    return true
  }

  return SENSOR_MAPA_WHITELIST_IDS.has(Number(sensor.tipoSensor))
}
